var _style, _defs, _mask, _g, _path, _defs2, _mask2, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _defs3, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareConnectCollab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1091 585",
    style: {
      enableBackground: "new 0 0 1091 585"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{mask:url(#mask0_1_);}\n\t.st2{fill:#F49460;}\n\t.st3{fill:#142040;}\n\t.st4{fill:#1E3340;}\n\t.st5{fill:#495B8E;}\n\t.st6{fill:#495A63;}\n\t.st7{fill:#FD5E5A;}\n\t.st8{fill:#13AA86;}\n\t.st9{fill:#31C6A8;}\n\t.st10{fill:#FFC258;}\n\t.st11{fill:#99CFFF;}\n\t.st12{fill:#FEC4B7;}\n\t.st13{fill:#111F59;}\n\t.st14{fill:#18287D;}\n\t.st15{fill:#6F81A6;}\n\t.st16{fill:#7397E1;}\n\t.st17{fill:#8D9BB9;}\n\t.st18{fill:#C0E6FF;}\n\t.st19{fill:#FFFFFF;}\n\t.st20{fill:#FF9797;}\n\t.st21{fill:#FFF8CC;}\n\t.st22{fill:#FFF8CC;filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.st23{mask:url(#mask1_1_);}\n\t.st24{fill:#3C1709;}\n\t.st25{fill:#33405A;}\n\t.st26{fill:#0E0E0E;}\n\t.st27{fill:#121841;}\n\t.st28{fill:#F2B90C;}\n\t.st29{fill:#591914;}\n\t.st30{fill:#792D12;}\n\t.st31{fill:#D1F0FF;}\n\t.st32{fill:#D1596A;}\n\t.st33{fill:#F27581;}\n\t.st34{fill:#F9CDE1;}\n\t.st35{fill:#E7A7C4;}\n\t.st36{clip-path:url(#SVGID_2_);}\n\t.st37{fill:#393644;}\n\t.st38{fill:#1D1B22;}\n\t.st39{fill:#313451;}\n\t.st40{fill:#283E6D;}\n\t.st41{fill:#53617D;}\n\t.st42{fill:#A1F3EF;}\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: -99,
    y: 39,
    width: 397,
    height: 618
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -99,
    y: 39,
    width: 397,
    height: 618,
    id: "mask0_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323,0H0v538h323V0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137,350l-8-18.6l40-18.4l11,21.5l-3.4,1.6l-9.4-18.2l-33.3,15.3l6.7,15.5L137,350z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M101.1,206c0,0,13.5,57.2,20.3,63.9c6.8,6.7,22.8,40.1,22.8,40.1s14.8,7.2,14.8,15l-3.5,5.6l-6.8,2.6l-3.4,1.8 h-3.7c0,0-1-9.5-5.8-16.5c-4.7-7-24.3-23.9-34.7-46.8C90.7,248.8,78,213.4,78,213.4L101.1,206z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62,380l196.5-85.7l13.4,27.4L75.4,407.4L62,380z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M49,381l57-24.8l17,34.8l-57,24.8L49,381z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62,396.5c4.6,9.6,6.4,18.3,3.9,19.3c-2.5,1.1-8.2-5.8-12.8-15.4c-4.6-9.6-6.4-18.3-3.9-19.3 C51.6,380,57.3,386.9,62,396.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M228.1,302.3c-2.5,1.1-0.7,9.7,4,19.2c4.7,9.5,10.5,16.4,13,15.3l51.8-22.3L280,280L228.1,302.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M293,295.5c4.6,9.6,6.4,18.3,3.9,19.4c-2.5,1.1-8.2-5.8-12.8-15.4c-4.6-9.6-6.4-18.3-3.9-19.4 S288.3,285.9,293,295.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M274.8,288.6L230.5,308c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.2c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1 c0,0,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1l44.3-19.4c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0.1,0.2,0.2c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1 c0,0,0,0.1-0.1,0.1S274.8,288.6,274.8,288.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M274.8,294.6L230.5,314c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.2c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1 s0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1l44.3-19.4c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0.1,0.2,0.2c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1 c0,0,0,0.1-0.1,0.1C274.9,294.6,274.8,294.6,274.8,294.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M277.8,299.6L233.5,319c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.2c0,0,0-0.1,0-0.1s0-0.1,0-0.1 c0,0,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1l44.3-19.4c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0.1,0.2,0.2c0,0,0,0.1,0,0.1s0,0.1,0,0.1 c0,0,0,0.1-0.1,0.1C277.9,299.6,277.8,299.6,277.8,299.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M280.8,305.6L236.5,325c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.2c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1 s0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1l44.3-19.4c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0.1,0.2,0.2c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1 c0,0,0,0.1-0.1,0.1C280.9,305.6,280.8,305.6,280.8,305.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M51,415c0,0,25.1,45.7,23.5,59.3c-1.7,13.5-7,24.4-2.5,42.9c4.5,18.5,40.5,85.5,41.4,97.8 c0.3,5.2-1.3,5.6-1.3,5.6c0,8.9,2.9,18.4,4.9,20.3c2.5,2.4,5.3,14.1,7.7,14.1S147,657,147,657c0.5-4.3-5.6-0.9-9.2-9.9 c-3.6-9-5.7-22.5-10.2-40.8c-4.5-18.2-23-101.5-23-120.6c0-19.1,1.9-19.2-1.2-31.9c-3.1-12.6-14.7-36.3-14.7-36.3L51,415z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M78.1,258.5c0,0,4.2,64.2,7.5,79.5c3.3,15.3,22,123.7,22,123.7L128,605.6l-21.6,2.4L68.2,507.5l2.7-36.6 L33,364.7l17.6-107L66,257L78.1,258.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M90.7,162.6C84.1,143.8,70,129,70,129s2.1,34.9,5.1,48.7c1.8,8.5-2.1,32.7,5.1,47.3c4.6-2.4,18.8-7.9,23.9-9.3 C101.7,198.6,94.1,172.2,90.7,162.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.6,449.2c0,0-3.2,33-7.4,42.8c-4.2,9.8-0.8,139.6,2.7,150.1c0.8,2.2,1.7,4.3,3,6.2c3.9,6.4,4.8,7.7-0.5,7.7 c-6.7,0-12.6-1.2-13.9-3.9c-2.2-4.5-4.2-20.2-8.8-20.2c0,0-3.1-5.8-2.3-8.9c1.2-4.6,4.5-2.2,4.5-8.7c0-6.4-22-104.1-18.4-118.3 c3.5-14.2,6-15.9,6-32.8C4.4,446.4,39.6,449.2,39.6,449.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M70.8,128.9c0,0-11.2-8.2-49.1-0.7c-1.9,0.4-4.7,41.4-4.7,41.4s18.2,68.2,14.7,85.2c0,0,21.1,16.9,52.6,2.3 c0,0-3.9-53.5-1-65.4c2.9-11.9,8.7-22.7,0.6-35.1C75.8,144.2,70.8,128.9,70.8,128.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M70,261.9L18.6,149c-0.9,10.3-1.6,20.7-1.6,20.7s18.2,68.1,14.7,85.1C31.7,254.8,46.5,266.7,70,261.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M31,255c0,0-21.3,32.5-26.2,50.3c-4.9,17.9-2.4,156.5-2.4,156.5S-6,490.3-6,504c0,13.7,12.3,105,12.3,105h26.6 l8-137.8l23.7-137.9l13.3-74L31,255z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M33,609c1.7-36.8,0.6-95.8,3.1-138.2C44.3,423.7,51.2,410.1,60,362c-0.6,3.5-7.7,47.6-13.6,81.8L41.7,471 l0-0.1C40,502.5,35.6,573.5,33,609z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M18.1,178.5c7.4-7.5,7.9-10.6,7.9-24.7c-0.1-8.8-1.6-17.5-4.5-25.8c0,0-15.3,1.3-20.9,18.6 c-6.9,21.4-36.9,51-36.5,71.9c6.5-3.1,19.4,7.1,26.7,6.5C-7.7,211.5,11.9,184.9,18.1,178.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M18,178c7.3-8,7.7-10.2,7.6-24.2c-0.1-8.7-1.5-17.4-4.1-25.8c1.8,4.1,3.2,8.3,4,12.7c2,9.3,1.7,21,0.4,26.3 c-0.6,2.2-1.6,4.3-3,6.1C21.5,174.9,19.8,176.5,18,178z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M20.8,81c5.4,5.2-0.1,17.8-5.6,19L15,98.2c4-0.5,10.4-11.7,5.6-17L20.8,81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M15.8,66c-0.1-4.4-1.3-13.4-5.8-12.1c-4.6,0.7,0.3,7.8,4.2,4.8c1.6-1.3,1.8-3.8,1-5.6 c-2.6-5.7-15.6-3.8-12.7,1.7l-3.4,0.5c-1.7-10.5,19.6-9.5,17.8,1c-0.6,3.3-3.6,4.7-6,3.9C7,59,5.5,53.7,9.7,53.1 c5.3-1.4,6.6,7.7,6.8,12.9L15.8,66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.1,82c0,0-4.1,36.1,3.1,46.7c4,6,10.5,6.7,15.3,6.2c0.8-0.1,1.7-0.4,2.4-0.8c0.7-0.4,1.4-1,1.9-1.7 c0.5-0.7,0.9-1.5,1-2.3c0.2-0.8,0.2-1.7,0-2.6c-1.9-9.2-5.1-26.9-3.5-34.9C54.6,81.6,32.1,82,32.1,82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M32.7,82c0,0-0.4,3.2-0.7,8c3.9,7.4,8.9,14.2,14.7,20.2c2.6,2.8,5.4,5.4,8.3,7.7c-1.6-9-3-19.9-1.8-25.6 C55.4,81.6,32.7,82,32.7,82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.8,60.2c1.1-3.7,5.5-9,11.3-12.5c12.6-7.5,28.5,1.4,30.5,16.7c0.2,1.4,0.2,2.7,0,4.1 c-1.1,8.4,5.4,13,5.4,13c-0.1,0.6-0.4,1.2-0.9,1.6s-1,0.8-1.6,0.9c-2.1,0.5-1.8,1.5-1.2,2.8c0.7,1.3,1.4,1.5,0.9,2.5 c-0.5,1-2.6,1.4-2.6,1.4s1.5,2,0.9,3.1c-0.1,0.3-0.3,0.5-0.6,0.7c-0.3,0.2-0.6,0.3-0.9,0.3c0,0-1.9,0.9-1.5,2.2 c0.4,1.3-0.5,2.8-1.2,3.9c-1,1.5-7.1,8.6-22.8-5.2C25,81.9,22.4,68.6,24.8,60.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M3.1,58.6c0,0-9.3-3.5-12.7-0.1c-3.4,3.4-1.5,8.3-1.5,8.3s-3.4-3-3.8,6.6c-0.4,9.6,23.7,28.2,33.6,12.3 C28.5,69.9,4.6,59,3.1,58.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M18.7,78c-4.5-1.7-13.4-3.6-13.3,0.9c-0.2,6.9,9.2,8.5,8.2,3.5c-0.5-4.5-10-3.6-11.2,0.1 c-1.4,4.2,3.2,9,8.4,6.5l1.1,2.2c-10.2,4.5-16-9.5-8.1-12.7c4.5-1.8,11.2-0.9,11.5,3.8c0.1,0.9,0,1.8-0.4,2.5 c-0.4,0.8-1,1.4-1.8,1.8c-0.8,0.3-1.6,0.4-2.4,0.3c-0.8-0.1-1.6-0.3-2.3-0.8c-4.7-2.3-5-7.8-3.3-9.5c2.8-3,10.2-0.9,14.1,0.6 L18.7,78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M36.8,39.1c-15.8,1.1-18.3,14.4-21.4,27C12.2,78.6,29.8,87.6,31.2,87c0,0,5.4-15.1,11.2-15.3 c5.9-0.2,21.6-12.8,21.6-12.8C69.2,48.4,52.6,38,36.8,39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.4,71.1c0,0,2.7-4.3-3.4-5.9c-6.1-1.6-6.2,8.3-2.8,11.2C40.6,79.3,43.4,71.1,43.4,71.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M41.4,72.6c0,0,1.8-4.9-1-4.6c-2.7,0.3-4.6,5.6-2.6,6.7C39.8,75.9,41.4,72.6,41.4,72.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M37.4,327L-99,86.3c0,0,24.7,2.9,41-17.3L49,320.5L37.4,327z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M-45.4,133.9l-15.1-24.6c0,0-4.4-6.5,12.3-13.6c10-4.2,18.1-7.1,20.8-2.1C-24.7,98.7,6,174,6,174L-45.4,133.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M-27,94l21.1,42.8L107,366.4c-1.6,2.9-4.7,5.9-8.9,7.8c-0.6,0.3-1.1,0.5-1.7,0.7l-153-245.2L-67,113.1 C-67,113.1-41.6,116.1-27,94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-43,133.4c-10.7,5.1-21.2,5.8-24,1.7L78.1,374l0,0c2.6,4.1,9.3,5.2,15.3,2.4c6.1-2.9,9.2-8.9,6.8-13.4 L-27.5,116C-25.3,120.5-32.2,128.2-43,133.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M100,363C30.9,232-28,116.1-28,116C26.8,219.9,19.9,206.7,100,363z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-36.9,218.3c-0.6,4.7-3,14.3,1.8,15.6c12.8,3.6,49,4.8,61.4-0.3c15.9-6.7,13.6-10.4,13.6-10.4 c-0.6-0.5-1.1-1.1-1.4-1.8c-0.3-0.7-0.4-1.5-0.4-2.2c0-2.9-3.1-6.2-4.7-7.8s-8.9,2.9-9.6,3.5c-0.7,0.7-6.6,13.3-14.3,11.2 c-7.8-2.1-30.9-11.4-40.2-12.5c-0.7-0.1-1.5-0.1-2.2,0.1c-0.7,0.2-1.4,0.5-1.9,0.9c-0.6,0.4-1.1,1-1.4,1.6 C-36.6,216.9-36.8,217.5-36.9,218.3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1091,47H769v538h322V47z"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 807,
    y: 137,
    width: 337,
    height: 878
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 807,
    y: 137,
    width: 337,
    height: 878,
    id: "mask1_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1087,47H765v538h322V47z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M989,179.7c0,0,31.7,13.7,54.6,19.6c22.9,5.9,28.3,11.8,32.5,10.6c4.2-1.3-7.2-18.2-7.2-18.2l-42-20.8 L991,165L989,179.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M965,333c0,0-8.4,46.8-34.9,78.3c-19.8,23.6-61.1,49.8-61.1,49.8l23.4,23.8l64.6-49.5L965,333z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1000.8,289h52.2l-1.7,157.7L982,451L1000.8,289z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1078.7,835.2l27.3-213.9l-7.7-63.3H947.9l-1.1,55.8L931,831.1c0,0,39.2,180.9,38.6,183.9H998 c-0.1-0.7-8-198.4-8-198.4l32.5-176.1l12.7,184.9c0,0-5.8,166.7-5.9,189.6h26.7C1055.9,1014.5,1078.7,835.2,1078.7,835.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M1099,566.4l-1-8.4H947.1l-0.1,7.3l31.7,10c25.8,8.2,53.3,8.8,79.4,1.9L1099,566.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M1107.6,331.5c-16.3-17-54.1-44.1-95.8-37.5l-43.5,17.9l-12.8,86.9L944,564.4l155.3,1.6l14.8-161.2 C1114,404.8,1123.9,348.5,1107.6,331.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1007.3,254.8c0,0-0.4,33.8-4,51.1c-1.4,6.7,2,13.5,8.2,15.9c5.8,2.2,12.1,2.7,18.2,1.6 c19.7-3.4,20.3-23.7,20.3-23.7l-6.6-61.7L1007.3,254.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1043.1,238l-36,16.8c0,0-0.2,12.5-1.1,26.2c9.4,0.4,21.2-4.5,33.8-19.2c1.9-2.2,3.6-4.4,5.2-6.5L1043.1,238z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1009.6,167.3c0,0-12.3,9.7-17.6,26c-5.3,16.3-10,28-10,28l5.7,3.5c0,0-4.5,22.7-1,30.5 c5.3,11.8,27.8,21.3,53.3-5.2c25.5-26.5,27.6-49.9,23.3-61.3C1058.9,177.3,1019.6,161.4,1009.6,167.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M992,179.7c20-7.1,8.7-25.3,61.2-11.8c2.6,2.5,5.7,4.6,9.1,5.2c9.6,1.7,8.6,21.7,8.6,21.7s5.6,4.1,1.7,18.6 c-4,14.5-27.4,36.6-27.4,43.5c0,0-5.7-8.7-1.1-22.9c4.6-14.1,4.6-22.4-0.3-22.4c-5,0,4-19,4-19c-3.9-2.9-8.3-5-13.1-5.9 c-4.8-1-9.7-0.8-14.4,0.4c-16.2,4.1-21.7-2.2-18.5-5.5C998.4,181.7,995.1,181,992,179.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1040.8,221c0,0,1.6-12,5.1-12c3.5,0,6.8,1.3,6,8.1c-0.8,6.8-4.5,14.3-9.1,11.2 C1038.1,225.1,1040.8,221,1040.8,221z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M996,295l-11.6,322H912l21.3-146.3l14-88.9c0,0,6.8-59.8,21.5-70.5C977.4,305.1,986.5,299.6,996,295z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1042.4,216.5c0,0,2.2-4,4.1-3.4c1.9,0.6,2.4,8.6-1.1,11.9C1042,228.3,1039.2,222.8,1042.4,216.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1053.6,294l-7.6,324h77.5c0,0,2.9-256.8-5.7-283.6S1053.6,294,1053.6,294z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M968,306.9l33-17.9l-10.6,159l-18.1-89.9l6.4-4.1L968,306.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1050,450l2.9-161l30.1,12.4l-16.4,52.4l4.2,2.9L1050,450z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M914,494l-107-75.3l113.3-9.7l85.7,85L914,494z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M973.5,463c0,0,11.6,2.5,15.9,6.8c5.5,5.6,18.5,14.6,23.9,14.6c5.5,0,28.7,2.2,28.7,2.2l3.9,24.3 c0,0-86.8-18.9-90.9-23.1c-4.1-4.2,20.4,3.1,20.4,1.2s-29.4-3.9-27.9-8.6c1.5-4.7,27.2,6.3,29.5,4c2.3-2.3-31-6.2-31-11.1 c0-4.9,33.1,7.1,33.1,7.1s0.6-2.5-8.3-6.5c-9-4-17.6-7.3-15.7-9.3c2-2,24.9,10.8,27.9,7.7L973.5,463z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1096.5,327.2c0,0-12.7,21.9-10.1,53.4c2.5,31.5,6.8,79.9-0.3,95.7c-7.1,15.8-59.1,0-59.1,0v37.3 c0,0,75.4,28.9,97.2,19.5c21.8-9.5,19.8-91,19.8-130.9C1143.9,362.2,1110.4,298.5,1096.5,327.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M882.4,461.4c0,0-1.5,1.7-3.9,7c-2.3,5.1,4.2,10.3,5.5,11.4c3,2.4,6.2,4.6,9.5,6.4c2.2,1.3,4.6,2.2,7.1,2.7 c3.9,0.8,12.5-11.9,11.3-13.1c-0.8-0.8-1.8-1.5-2.7-1.2c-0.9,0.3-10.5,7.2-10.5,7.2s8.7-10,7.7-12.9c-1-3-2.8-2.6-3.6-1.9 c-0.8,0.8-11.8,10.1-11.8,10.1s7.4-11.9,6.8-13.9c-0.6-1.9-3.6-3.3-7,1.5c-1.9,2.7-6.9,7.1-6.9,7.1s4.2-9,3.2-11.9 C886.1,457.1,882.4,461.4,882.4,461.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M1057,145.1c-0.1,0.4-9.3,32.3-9.3,31.9c-13.7-3.2-32.9-6.3-46.8-8.2c1.6-5.5,4.2-14.1,9.4-17.7 c7-4.9,19.2-12.7,29.7-12.1C1049,139.6,1053,143,1057,145.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1056,144.4c-0.1,0.4-9.8,33-9.7,32.6c-14.5-3.3-40.7-8.7-55.3-10.7c1.8-5.5,4.5-10.7,8-15.3 c4.4-5.7,12-9.6,18.9-11.9c6.6-2.2,13.7-2.7,20.5-1.3c5.5,1.2,10.8,3.1,15.8,5.7C1054.9,143.7,1055.5,144,1056,144.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1065,146.8l-12.3,32.2c-0.4-0.1-18.7-4.7-44.7-8.5c1.4-8.4,3.5-17.7,10.3-23.7c3.4-2.9,7.4-5.1,11.7-6.4 c4.3-1.3,8.8-1.7,13.3-1.1c4,0.6,7.8,2,11.3,3.9C1058.2,144,1061.7,145.3,1065,146.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1080.3,203c-7.1-14.8-45.2-29.3-63.3-31.9c0.5-4.4,1.3-15.5,5.2-20.1c14.6-17.1,57-9.3,63.4,18.9 C1087,175.9,1084.5,196.1,1080.3,203z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M1066.5,158c0,0-0.1,0-0.1,0l-6.1-2.2c-0.1,0-0.1,0-0.2-0.1s-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0-0.2s0-0.1,0-0.2 c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2,0,0.3,0l6.1,2.2c0.1,0,0.1,0,0.2,0.1c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2 c0,0.1-0.1,0.2-0.2,0.2C1066.7,158,1066.6,158,1066.5,158z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M1065.5,161c0,0-0.1,0-0.1,0l-5.1-2.2c-0.1,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1s0-0.1,0-0.2s0-0.1,0-0.2 c0-0.1,0.1-0.2,0.3-0.2c0.1,0,0.2,0,0.3,0l5.1,2.2c0.1,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1s0,0.1,0,0.2s0,0.1,0,0.2 c0,0.1-0.1,0.2-0.2,0.2C1065.7,161,1065.6,161,1065.5,161z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M1079.5,165c-0.1,0-0.1,0-0.2-0.1l-5.1-3.1c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.2c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2,0,0.3,0l5.1,3.1c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.2 c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1-0.1,0.2c0,0.1-0.1,0.1-0.2,0.2C1079.7,165,1079.6,165,1079.5,165z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M1078.5,168c0,0-0.1,0-0.1-0.1l-5.1-3c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.2c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2,0,0.3,0l5.1,3c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2 c0,0.1,0,0.1-0.1,0.2c0,0.1-0.1,0.2-0.2,0.2C1078.7,168,1078.6,168,1078.5,168z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M1072,160.2c-0.1,0.3-0.3,0.5-0.6,0.7c-0.3,0.2-0.7,0.2-1.1,0.2c-0.2,0-0.4-0.1-0.5-0.1 c-0.2-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1-0.1-0.1-0.3,0-0.4c0.1-0.3,0.3-0.5,0.6-0.7c0.3-0.2,0.7-0.2,1.1-0.2 c0.2,0,0.4,0.1,0.5,0.1c0.2,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.2,0.2,0.3,0.4C1072,159.9,1072,160,1072,160.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M1002.4,159.5c17.8,3,59.6,13.8,75.7,38.5c0,0,7.4,10.2-1.2,11c-0.3-3.3-2.7-8-5.4-9.7 c-17.6-11.7-47.5-25.5-75.2-21.5c-2.6,0.4-6.4,0.3-7.1,1.5c-4.3-1.5-8.3-3.8-11.7-6.9C969.3,164.8,969.5,154,1002.4,159.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M977.7,172.7c-3.3-3.4-6-7.9-2.8-11.1c2.8-2.7,8.7-2.9,12.6-3c14.3-0.5,30.4,4.6,43.7,9.6 c38.9,13.9,58.3,40.2,45.5,41.8c11.8-0.9-3.1-19.2-12.8-26.9c-28.1-21.9-93.2-35.9-90.8-17.7C973.5,168.4,975.6,170.8,977.7,172.7z "
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M704,22H382v537h322V22z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M625,450.5c0,42.8-36.7,77.5-82,77.5c-29.3,0-55.1-14.6-69.6-36.5c-8.1-12.2-12.4-26.4-12.4-41 c0-42.8,36.7-77.5,82-77.5c17.8-0.1,35.1,5.4,49.5,15.7C612.3,402.9,625,425.3,625,450.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M605,429.7c0,42.7-36.7,77.3-82,77.3c-17.8,0.1-35.1-5.4-49.6-15.7c-8.1-12.1-12.4-26.4-12.4-41 c0-42.7,36.7-77.3,82-77.3c17.8-0.1,35.1,5.4,49.6,15.7C600.7,400.8,605,415.1,605,429.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M390,250l159.6-58.1l61.5,150.8l-159.6,58.1L390,250z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M525,200.1L587.7,351l24.3-9l-61.8-151L525,200.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M585,74L482,174.4L625,209L585,74z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M574,196.2l11.1-119.4l0.2-2.8L625,208L574,196.2z"
  })), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0,
    className: "st34",
    width: 321.3,
    height: 537
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 1,
    y: 0,
    width: 303.6,
    height: 537
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st36"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "129.5,349.5 122,330.9 159.4,312.7 169.7,334 166.5,335.6 157.7,317.4 126.6,332.7 132.8,348.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95.8,205.1c0,0,12.7,56.9,19,63.7c6.4,6.7,21.4,39.9,21.4,39.9s13.9,7.1,13.9,15l-3.3,5.5l-6.4,2.6 l-3.2,1.8h-3.4c0,0-1-9.4-5.4-16.4c-4.4-7-22.8-23.8-32.5-46.6c-9.7-22.8-21.7-58-21.7-58L95.8,205.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 55.9,
    y: 335.1,
    transform: "matrix(0.9082 -0.4186 0.4186 0.9082 -132.1048 98.1843)",
    className: "st3",
    width: 203.7,
    height: 30.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.8,
    y: 365.4,
    transform: "matrix(0.9082 -0.4186 0.4186 0.9082 -153.4827 69.2963)",
    className: "st3",
    width: 58.8,
    height: 38.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.7,394.8c4.4,9.6,6.1,18.2,3.7,19.3c-2.3,1.1-7.8-5.8-12.2-15.4c-4.4-9.6-6.1-18.2-3.7-19.3 C48.9,378.4,54.3,385.3,58.7,394.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M215.6,301.5c-2.3,1.1-0.7,9.7,3.7,19.3c4.4,9.6,9.9,16.4,12.2,15.4l48.6-22.4l-16-34.6L215.6,301.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M276.4,294.5c4.4,9.6,6.1,18.2,3.7,19.3c-2.3,1.1-7.8-5.8-12.2-15.4c-4.4-9.6-6.1-18.2-3.7-19.3 C266.5,278,272,284.9,276.4,294.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M259.2,287.5l-41.6,19.2c-0.2,0.1-0.3,0-0.4-0.2c-0.1-0.2,0-0.3,0.2-0.4l41.6-19.2 c0.2-0.1,0.3,0,0.4,0.1C259.5,287.2,259.4,287.4,259.2,287.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M259.5,294l-41.6,19.2c-0.2,0.1-0.3,0-0.4-0.1c-0.1-0.2,0-0.3,0.1-0.4l41.6-19.2c0.2-0.1,0.3,0,0.4,0.2 C259.8,293.8,259.7,293.9,259.5,294z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M261.8,298.9l-41.6,19.2c-0.2,0.1-0.3,0-0.4-0.1c-0.1-0.2,0-0.3,0.2-0.4l41.6-19.2 c0.2-0.1,0.3,0,0.4,0.2C262,298.7,262,298.9,261.8,298.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M265.2,304.3l-41.6,19.2c-0.2,0.1-0.3,0-0.4-0.2c-0.1-0.2,0-0.3,0.1-0.4l41.6-19.2 c0.2-0.1,0.3,0,0.4,0.2C265.4,304,265.3,304.2,265.2,304.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M48.7,414.2c0,0,23.7,45.6,22.2,59.1c-1.6,13.5-6.7,24.3-2.4,42.8c4.3,18.4,38.3,85.3,39.1,97.5 c0.3,5.1-1.2,5.6-1.2,5.6c0,8.9,2.8,18.4,4.6,20.2c2.4,2.4,5,14.1,7.2,14.1c2.2,0,21.2,2.1,21.2,2.1c0.5-4.3-5.3-0.9-8.7-9.9 c-3.4-9-5.4-22.5-9.7-40.7c-4.3-18.2-21.7-101.2-21.7-120.3c0-19.1,1.8-19.2-1.2-31.8c-2.9-12.6-13.9-36.2-13.9-36.2 L48.7,414.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M74.1,258.2c0,0,3.9,64.1,7,79.4c3.1,15.3,20.7,123.6,20.7,123.6L121,605l-20.3,2.4L64.9,507l2.5-36.6 L31.8,364.3l16.5-106.9l14.5-0.7L74.1,258.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M133.4,649.8c4.4,4.2,11.2,3.3,10.8,6.8c0,0-24.6-1.1-26.8-1.1c-2.2,0-4.2-13.8-6.5-16.2 c-2.4-2.4-0.9,16.2-0.9,16.2h-2.4c0,0-1.6-19.1-3.9-26.5c-1.8-5.9,0.8-8.4,2.6-9.9C113.7,633.3,114.8,653.1,133.4,649.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M86.4,161.6c-6.2-18.7-19.6-33.5-19.6-33.5s2,34.8,4.8,48.5c1.7,8.5-2,32.6,4.8,47.2 c4.4-2.4,17.7-7.8,22.5-9.3C96.8,197.5,89.6,171.2,86.4,161.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "17.4,632.6 17.6,653.5 15.3,653.6 12.4,629.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38,448.3c0,0-3,32.9-7.1,42.7c-4,9.8-0.8,139.2,2.6,149.6c0.7,2.3,1.8,4.4,2.8,6.2 c3.7,6.4,4.5,7.7-0.4,7.7c-6.4,0-12-1.2-13.2-3.9c-2.1-4.5-4-20.1-8.4-20.1c0,0-3-5.8-2.2-8.9c1.1-4.6,4.3-2.2,4.3-8.6 c0-6.4-20.9-103.8-17.5-117.9c3.4-14.2,5.7-15.8,5.7-32.7C4.5,445.5,38,448.3,38,448.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M66.9,128.1c0,0-10.6-8.2-46.2-0.7c-1.7,0.4-4.4,41.4-4.4,41.4s17.2,68.1,13.8,85.1 c0,0,19.8,16.8,49.5,2.3c0,0-3.7-53.5-0.9-65.4c2.7-11.9,8.2-22.7,0.6-35.1C71.6,143.4,66.9,128.1,66.9,128.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M66.1,261L17.8,148.1c-0.9,10.3-1.5,20.6-1.5,20.6s17.2,68.1,13.8,85.1C30,253.9,44,265.8,66.1,261z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M30,253.9c0,0-20,32.4-24.6,50.3C0.8,322,3.2,460.4,3.2,460.4s-8,28.4-8,42.2 c0,13.7,11.6,104.8,11.6,104.8h25l7.5-137.6l22.3-137.7l12.5-73.9L30,253.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M31.8,607.4c1.6-36.7,0.5-95.5,2.9-137.7c7.6-46.9,14.1-60.5,22.2-108.5c-0.5,3.5-7.1,47.4-12.6,81.5 l-4.3,27.1l0-0.1C38.3,501.3,34.2,572,31.8,607.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M17.4,177.6c7-7.5,7.4-10.6,7.4-24.5c0-14-4.2-25.7-4.2-25.7S6.2,128.7,1,145.9 c-6.5,21.3-34.7,50.6-34.3,71.4c6.1-3.1,18.2,7.1,25,6.5C-6.7,210.4,11.6,183.9,17.4,177.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M17.4,177.6c6.5-8,6.9-10.2,6.8-24.3c0-8.6-1.4-17.6-3.7-25.9c1.6,4.1,2.8,8.4,3.6,12.7 c1.8,9.3,1.5,21.1,0.3,26.4c-0.5,2.2-1.4,4.3-2.7,6.1C20.5,174.5,19,176.1,17.4,177.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M16,616c1.9,11.7,9.3,31.1,14,33.8c7.8,2.2,6.4,1.1,6.4-3c3.7,6.4,7.9,9.6,2.9,9.6 c-6.4,0-16.4,0.4-17.6-2.2c-2.1-4.5-3.3-21.7-7.7-21.7l1.4,21.1l-2.3,0.1c0,0-3.4-29.1-2.7-32C11.3,617.7,14.7,616.7,16,616z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M19.9,80c5.2,5.1-0.1,17.3-5.4,18.6l-0.2-1.7c3.9-0.5,10.1-11.4,5.4-16.6L19.9,80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M15,66.4c-0.1-4.5-1.2-13.7-5.3-12.3c-4.2,0.7,0.3,8,3.9,4.9c1.5-1.3,1.7-3.8,0.9-5.7 C12,47.4,0.2,49.3,2.9,55l-3.1,0.5c-1.5-10.7,17.9-9.7,16.2,1c-0.6,3.4-3.3,4.8-5.5,4c-3.5-1.2-4.9-6.6-1-7.2 c4.8-1.5,6.1,7.8,6.2,13.1L15,66.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.8,81.7c0,0-3.9,35.7,2.9,46.1c3.8,5.9,9.9,6.6,14.5,6.1c3.5-0.4,5.7-3.8,5-7.3 c-1.8-9.1-4.9-26.6-3.3-34.4C52.1,81.3,30.8,81.7,30.8,81.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M30.8,81.7c0,0-0.4,3.3-0.7,8.1c3.1,6.4,7.5,13.2,13.7,20.3c2.9,3.4,5.5,5.9,7.8,7.8 c-1.5-9-2.8-20-1.7-25.7C52.1,81.3,30.8,81.7,30.8,81.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.6,59.9c1-3.7,5.2-8.9,10.7-12.3c11.9-7.4,26.9,1.4,28.7,16.5c0.2,1.4,0.2,2.7,0,4 c-1,8.3,5.1,12.8,5.1,12.8s-0.3,1.9-2.3,2.5c-2,0.5-1.7,1.5-1.1,2.8c0.6,1.3,1.3,1.5,0.8,2.5c-0.5,1-2.5,1.3-2.5,1.3 s1.4,2,0.9,3.1c-0.5,1.1-1.3,1-1.3,1s-1.8,0.9-1.4,2.2c0.4,1.3-0.4,2.8-1.1,3.8c-0.9,1.5-6.7,8.5-21.5-5.1 C23.7,81.5,21.3,68.2,23.6,59.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M3.6,58.5c0,0-8.8-3.5-12-0.1c-3.2,3.4-1.4,8.3-1.4,8.3s-3.2-3-3.6,6.6c-0.4,9.6,22.4,28.1,31.8,12.3 C27.7,69.8,5,58.9,3.6,58.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M18.4,77.3c-4.3-1.7-12.7-3.6-12.6,0.9c-0.2,6.9,8.7,8.5,7.8,3.4c-0.4-4.5-9.5-3.6-10.6,0.1 c-1.3,4.2,3,9,7.9,6.4l1,2.1c-9.6,4.5-15.2-9.5-7.7-12.6c4.2-1.7,10.6-0.9,10.9,3.8c0.2,1.6-0.4,3.5-2.1,4.3 c-1.7,0.7-3.3,0.1-4.5-0.5C4,83,3.8,77.5,5.4,75.8c2.6-3,9.6-0.9,13.3,0.6L18.4,77.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M35.7,38.7C20.8,39.8,18.4,53,15.4,65.4c-3,12.4,13.6,21.3,15,20.7c0,0,5.1-15,10.6-15.2 c5.6-0.2,20.4-12.6,20.4-12.6C66.3,47.9,50.6,37.6,35.7,38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.1,70.9c0,0,2.6-4.3-3.3-5.9c-5.9-1.6-5.9,8.2-2.7,11.1C38.4,79,41.1,70.9,41.1,70.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M39.2,71.5c0,0,1.7-4.8-0.9-4.5c-2.6,0.3-4.5,5.4-2.5,6.5C37.6,74.6,39.2,71.5,39.2,71.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M-73.9,105.3l-11.7-22.5c0,0-3.5-6,12.5-12.3c9.5-3.8,17.2-6.4,19.2-1.8c2.1,4.6,23.6,73.5,23.6,73.5 L-73.9,105.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M-68.2,75c-4.6,5.4-11.1,7.6-17.4,7.8l11,24.6c0,0,19.5,6.2,16.2-4C-61.6,93.1-68.2,75-68.2,75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M36.1,326.2L-92.6,85.9c0,0,23.3,2.9,38.7-17.2L47.1,319.8L36.1,326.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M-41.5,133.2l-14.1-24.6c0,0-4.2-6.5,11.5-13.6c9.3-4.2,16.9-7.1,19.4-2.1c2.6,5.1,31.2,80.4,31.2,80.4 L-41.5,133.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M-38.6,100c-4.1,5.9-10.6,8.4-17,8.6l13.6,26.9c0,0,20.5,6.7,16.2-4.5C-30.1,119.7-38.6,100-38.6,100z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M-16.8,110.5c2.3,4.5-6.1,13.3-18.8,19.7c-12.6,6.4-24.7,7.9-27,3.5c-2.3-4.5,6.1-13.3,18.8-19.7 C-31.2,107.6-19.1,106.1-16.8,110.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M-24.6,92.9l19.9,42.8l106.7,229.4c-1.5,2.9-4.4,5.8-8.4,7.8c-0.5,0.3-1.1,0.5-1.6,0.7l-144.6-245 l-9.8-16.6C-62.4,112-38.4,115-24.6,92.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M-62.6,133.7L-62.6,133.7L-62.6,133.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "-16.8,110.5 -16.8,110.5 -16.8,110.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-39.9,132.3c-10,5.1-19.9,5.8-22.5,1.7L74,373.1l0,0c2.4,4.1,8.7,5.2,14.3,2.4 c5.8-2.9,8.6-8.9,6.4-13.4l-120-247.2C-23.2,119.4-29.7,127.2-39.9,132.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M94.7,362.1C30,231-25.2,115-25.3,114.9C26.1,218.9,19.6,205.7,94.7,362.1z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-34.1,218c-0.5,4.7-2.8,14.3,1.7,15.6c12,3.6,46,4.8,57.6-0.3c14.9-6.7,12.8-10.4,12.8-10.4 s-1.6-1.2-1.6-4.1c0-2.9-2.9-6.2-4.5-7.7c-1.6-1.6-8.3,2.9-9,3.5c-0.6,0.6-6.2,13.3-13.5,11.2c-7.3-2.1-29-11.4-37.7-12.5 C-31.8,212.9-33.8,215.6-34.1,218z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareConnectCollab);
export default __webpack_public_path__ + "static/media/Share_Connect_Collab.58ee98690a6b27a289ebca66e6d8a550.svg";
export { ForwardRef as ReactComponent };